module.exports = __webpack_public_path__ + "static/media/page10.0108428e.jpg";